import SV from 'server-vars';
import { sessionStorage } from 'dibs-browser-storage';
import { getEverLoggedIn, getUserId } from 'dibs-cookie-jar';
import { PAGE_TYPE, BROWSE_TYPES } from '../../utils/pageConstants';
import qs from 'querystring';
import {VisitCountModel} from 'dibs-visit-tracking';
import authModalLoader from '../../utils/AuthModalLoader';
import * as postAuthLoader from './helpers/postAuthLoader';
import isPageType from '../../utils/isPageType';

const isPlaReferrer = () => {
    const query = qs.parse(location.search);
    const utmMedium = query.utm_medium ? query.utm_medium.toLowerCase() : '';
    return utmMedium === "pla" || (typeof query.product !== 'undefined' && typeof query.gclid !== 'undefined');
};

const isAllowedPageType = () => {
    const isPdpPrintPage = SV.get('settings.isPrintPDP');
    const allowedPageTypes = [
        PAGE_TYPE.HOME,
        PAGE_TYPE.CREATOR,
        PAGE_TYPE.DEALER,
        PAGE_TYPE.PDP
    ];

    const isAllowedPage = isPageType([...allowedPageTypes, ...BROWSE_TYPES]);

    return isAllowedPage && !isPdpPrintPage;
};

/**
 * should visitor be prompted to login?
 * @returns {boolean}
 */
const isBlocked = function isBlocked() {
    const query = qs.parse(location.search);
    const loggedIn = getUserId(document.cookie);
    if (loggedIn || query.modal || !isAllowedPageType() || isPlaReferrer()) {
        return true;
    }
    return false;
};

const shouldPromptLoginRegistration = (visitCountModel) => {
    return (visitCountModel.get('session') === visitCountModel.get('regPromptLimit'));
};

const canAutoPromptUser = () => {
    const visitCountModel = new VisitCountModel();
    const isModalBlocked = isBlocked();
    const shouldOpenModal = shouldPromptLoginRegistration(visitCountModel);
    if (shouldOpenModal && !isModalBlocked) {
        return true;
    } else if (shouldOpenModal && isModalBlocked) {
        visitCountModel.increment('regPromptLimit');
        visitCountModel.save();
        return false;
    } else {
        return false;
    }
};

const getActionAndFlow = () => {
    let action = authModalLoader.constants.REGISTER;
    let flow = authModalLoader.constants.PAGEVIEW_LIMIT_FLOW;
    const ga = {};
    const everLoggedIn = getEverLoggedIn(document.cookie);
    if (everLoggedIn) {
        action = authModalLoader.constants.LOGIN;
        flow = authModalLoader.constants.PAGEVIEW_LIMIT_FLOW;
        if (everLoggedIn.toLowerCase() === "trade") {
            flow = authModalLoader.constants.PAGEVIEW_LIMIT_FLOW;
            ga.label = 'pageview limit reached - trade';
        }
    }

    return {action, flow, ga};
};


/**
 * prompts visitor to register if it's due
 * @return {boolean} true if login prompted
 */
const openLoginModal = () => (dispatch) => {
    const {action, flow, ga} = getActionAndFlow();

    sessionStorage.setItem('authModalShown', true);

    if (action === authModalLoader.constants.REGISTER && flow === authModalLoader.constants.PAGEVIEW_LIMIT_FLOW) {
        postAuthLoader.autoPromptRegistration({ flow });
    } else {
        authModalLoader.show({
            action: action,
            flow: flow,
            ga: Object.assign({
                label: 'pageview limit reached'
            }, ga)
        });
    }
    dispatch({type: 'noop'});
};


/**
 * Checks condition for auto prompt user.
 * Opens modal if condition is satisfied.
 * Condition:
 * page view >= 3,
 * home / browse / creator / pdp (not print) page type,
 * User is not logged in and AuthModal is not opened.
 *
 * @return {Promise}
 */
const loginPromptRule = function loginPromptRule() {
    if (canAutoPromptUser()) {
        return Promise.resolve(true);
    }
    return Promise.resolve(false);
};

module.exports = {
    name: "loginPrompt",
    rule: loginPromptRule,
    action: openLoginModal,
    priority: 250
};




// WEBPACK FOOTER //
// ./src/notificationQueue/globalNotifications/loginPrompt.js